import { createContext } from 'react';

export const AuthContext: any = createContext({});
